<script setup>
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import AsanaCreateFields from './AsanaCreateFields.vue';
import AsanaManageFields from './AsanaManageFields.vue';
import AsanaModalFooter from './AsanaModalFooter.vue';
import AsanaModalHeader from './AsanaModalHeader.vue';
import AsanaTaskSummaryCard from './AsanaTaskSummaryCard.vue';
import { useAsanaTaskForm } from './useAsanaTaskForm';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
  task: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['saved', 'deleted', 'close']);

const {
  description,
  dialogRef,
  dueLabel,
  errorMessage,
  form,
  isCompleted,
  isLoadingOptions,
  isManage,
  isSaving,
  open,
  close,
  deleteTask,
  priorityOptions,
  projectOptions,
  save,
  taskName,
  taskOptions,
  taskPermalink,
  taskProjectName,
  title,
  userOptions,
  workspaceOptions,
} = useAsanaTaskForm(props, emit);

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="xl"
    position="top"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="emit('close')"
  >
    <form class="flex flex-col gap-4" @submit.prevent="save()">
      <AsanaModalHeader
        :title="title"
        :description="description"
        :completed="isCompleted"
      />

      <AsanaTaskSummaryCard
        v-if="isManage"
        :completed="isCompleted"
        :name="taskName"
        :project-name="taskProjectName"
        :due-label="dueLabel"
        :permalink="taskPermalink"
      />

      <AsanaCreateFields
        v-if="!isManage"
        :form="form"
        :workspace-options="workspaceOptions"
        :project-options="projectOptions"
        :task-options="taskOptions"
        :loading-options="isLoadingOptions"
      />

      <AsanaManageFields
        v-else
        :form="form"
        :priority-options="priorityOptions"
        :user-options="userOptions"
        :loading-options="isLoadingOptions"
        :completed="isCompleted"
      />

      <p v-if="errorMessage" class="mb-0 text-sm text-n-ruby-10">
        {{ errorMessage }}
      </p>

      <AsanaModalFooter
        :manage="isManage"
        :completed="isCompleted"
        :saving="isSaving"
        @close="close"
        @delete="deleteTask"
        @complete="save(true)"
      />
    </form>
  </Dialog>
</template>
